import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
import { MagpieConnection } from 'magpie-lib/connection';
import { navVisibilityControls } from 'navigation-messaging/messages';
import { navigationPublicApiTopicDef } from 'navigation-messaging/topics';
var _instance = /*#__PURE__*/_classPrivateFieldLooseKey("instance");
export class NavInteractions {
  constructor(params) {
    this.getCurrentVisibility = () => {
      const topic = MagpieConnection.get().useTopic(navigationPublicApiTopicDef);
      const getVisibility = navVisibilityControls.getNavVisibility.create();
      return new Promise(res => topic.publish(getVisibility, {
        onReply: ({
          payload
        }) => res(payload)
      }));
    };
    this.useNavDisplayConfig = config => {
      if (!config) {
        return;
      }
      const topic = MagpieConnection.get().forTopic(navigationPublicApiTopicDef);
      const changeVisibility = navVisibilityControls.changeNavVisibility.create({
        source: this.params.appName,
        shouldShowVerticalNav: config.shouldShowNav,
        shouldShowToolbar: config.shouldShowToolbar
      });
      topic.publish(changeVisibility, {
        onReply() {}
      });
    };
    this.params = params;
  }
  static getInstance(params) {
    if (!_classPrivateFieldLooseBase(NavInteractions, _instance)[_instance]) {
      _classPrivateFieldLooseBase(NavInteractions, _instance)[_instance] = new NavInteractions(params);
    }
    return _classPrivateFieldLooseBase(NavInteractions, _instance)[_instance];
  }
}
Object.defineProperty(NavInteractions, _instance, {
  writable: true,
  value: void 0
});